import { Button } from "@v2/components/ui/button";
import { Textarea } from "@webV2/components/ui/textarea";
import { Edit3 } from "lucide-react";
import { useEffect, useRef } from "react";
import { DescriptionSectionProps } from "./types";

export const DescriptionSection = ({
  request,
  isAdmin,
  isEditing,
  editedDescription,
  onDescriptionChange,
  onStartEdit,
  onSave,
  onCancel,
  isLoading
}: DescriptionSectionProps) => {
  const descriptionTextareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (isEditing && descriptionTextareaRef.current) {
      setTimeout(() => {
        if (descriptionTextareaRef.current) {
          descriptionTextareaRef.current.focus();
        }
      }, 0);
    }
  }, [isEditing]);

  return (
    <div className="mb-8">
      {isEditing ? (
        <div className="space-y-4">
          <Textarea
            ref={descriptionTextareaRef}
            value={editedDescription}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              onDescriptionChange(e.target.value)
            }
            className="min-h-[200px] resize-none border-gray-200 text-gray-700 leading-relaxed focus:border-gray-300 focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
          />
          <div className="flex space-x-2">
            <Button
              onClick={onSave}
              size="sm"
              className="bg-gray-900 text-white hover:bg-gray-800"
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
            <Button
              onClick={onCancel}
              size="sm"
              variant="outline"
              className="border-gray-200 text-gray-600 hover:bg-gray-50"
            >
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div>
          {request.description ? (
            <div className="mb-4 whitespace-pre-wrap font-normal text-gray-700 text-sm leading-relaxed">
              {request.description}
            </div>
          ) : (
            <div className="mb-4 font-normal text-gray-700 text-sm leading-relaxed">
              No description provided yet
            </div>
          )}

          {isAdmin && (
            <Button
              onClick={onStartEdit}
              variant="outline"
              size="sm"
              className="border-gray-200 font-medium font-mona-sans text-[12px] text-gray-600 hover:bg-gray-50"
            >
              <Edit3 className="mr-2 h-4 w-4" />
              EDIT DESCRIPTION
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
